/**
 * Fase 2 (W25, K21): textos das exclusões novas (cadastro de funcionário feito por engano, oportunidade aberta ou perdida e
 * agendamento cancelado), que levam o registro à lixeira de 30 dias. Ficam no núcleo, ao lado da lixeira, porque são o
 * mesmo par "Excluir" e "Desfazer exclusão" nas três telas.
 */
export const exclusaoPt = {
  exclusao: {
    funcionario: {
      botao: 'Excluir cadastro',
      titulo: 'Excluir o cadastro?',
      texto:
        'Use só para cadastro feito por engano. O cadastro vai para a lixeira e pode voltar em até 30 dias. Quem já trabalhou (holerite, treinamento, acesso ao sistema) é desligado, não excluído.',
      feito: 'Cadastro excluído. Ele fica na lixeira por 30 dias.',
    },
    oportunidade: {
      botao: 'Excluir',
      titulo: 'Excluir a oportunidade?',
      texto: 'A oportunidade e as atividades dela vão para a lixeira e podem voltar em até 30 dias. Oportunidade ganha não é excluída.',
      feito: 'Oportunidade excluída. Ela fica na lixeira por 30 dias.',
    },
    agendamento: {
      botao: 'Excluir',
      titulo: 'Excluir o agendamento cancelado?',
      texto: 'O agendamento sai da agenda e vai para a lixeira, de onde pode voltar em até 30 dias.',
      feito: 'Agendamento excluído. Ele fica na lixeira por 30 dias.',
    },
    estrutura: {
      oQueFazer: 'O que fazer com os dados',
      arquivar: 'Arquivar junto',
      arquivarAjuda: 'Tudo fica guardado com ela, fora das listas. Nada é apagado.',
      transferir: 'Passar as verticais para outra empresa',
      transferirAjuda: 'Cadastros, produtos, funcionários e o que mais é marcado por vertical passam para a empresa escolhida. Lançamentos, contas, folha, ponto, fiscal, contratos e compras ficam com esta empresa, arquivada.',
      destino: 'Empresa que recebe',
      digite: 'Para confirmar, digite {{nome}}',
      excluir: 'Excluir',
      feito: 'Excluído. Os dados ficam arquivados, nada foi apagado.',
    },
  },
};

type Dic = typeof exclusaoPt;

export const exclusaoEn: Dic = {
  exclusao: {
    funcionario: {
      botao: 'Delete record',
      titulo: 'Delete the record?',
      texto:
        'Use only for a record created by mistake. The record goes to the trash and can come back within 30 days. Someone who already worked (payslip, training, system access) is terminated, not deleted.',
      feito: 'Record deleted. It stays in the trash for 30 days.',
    },
    oportunidade: {
      botao: 'Delete',
      titulo: 'Delete the opportunity?',
      texto: 'The opportunity and its activities go to the trash and can come back within 30 days. A won opportunity is not deleted.',
      feito: 'Opportunity deleted. It stays in the trash for 30 days.',
    },
    agendamento: {
      botao: 'Delete',
      titulo: 'Delete the canceled appointment?',
      texto: 'The appointment leaves the schedule and goes to the trash, where it can come back within 30 days.',
      feito: 'Appointment deleted. It stays in the trash for 30 days.',
    },
    estrutura: {
      oQueFazer: 'What to do with the data',
      arquivar: 'Archive with it',
      arquivarAjuda: 'Everything stays stored with it, out of the lists. Nothing is deleted.',
      transferir: 'Move the verticals to another company',
      transferirAjuda: 'Records, products, employees and anything else marked by vertical move to the chosen company. Entries, accounts, payroll, time clock, tax, contracts and purchases stay with this company, archived.',
      destino: 'Receiving company',
      digite: 'To confirm, type {{nome}}',
      excluir: 'Delete',
      feito: 'Deleted. The data stays archived; nothing was erased.',
    },
  },
};

export const exclusaoEs: Dic = {
  exclusao: {
    funcionario: {
      botao: 'Eliminar registro',
      titulo: '¿Eliminar el registro?',
      texto:
        'Úsalo solo para un registro creado por error. El registro va a la papelera y puede volver en hasta 30 días. Quien ya trabajó (recibo de nómina, capacitación, acceso al sistema) se da de baja, no se elimina.',
      feito: 'Registro eliminado. Queda en la papelera por 30 días.',
    },
    oportunidade: {
      botao: 'Eliminar',
      titulo: '¿Eliminar la oportunidad?',
      texto: 'La oportunidad y sus actividades van a la papelera y pueden volver en hasta 30 días. Una oportunidad ganada no se elimina.',
      feito: 'Oportunidad eliminada. Queda en la papelera por 30 días.',
    },
    agendamento: {
      botao: 'Eliminar',
      titulo: '¿Eliminar la cita cancelada?',
      texto: 'La cita sale de la agenda y va a la papelera, desde donde puede volver en hasta 30 días.',
      feito: 'Cita eliminada. Queda en la papelera por 30 días.',
    },
    estrutura: {
      oQueFazer: 'Qué hacer con los datos',
      arquivar: 'Archivar junto',
      arquivarAjuda: 'Todo queda guardado con ella, fuera de las listas. No se borra nada.',
      transferir: 'Pasar las verticales a otra empresa',
      transferirAjuda: 'Registros, productos, empleados y lo demás marcado por vertical pasan a la empresa elegida. Asientos, cuentas, nómina, control horario, fiscal, contratos y compras quedan con esta empresa, archivada.',
      destino: 'Empresa que recibe',
      digite: 'Para confirmar, escribe {{nome}}',
      excluir: 'Eliminar',
      feito: 'Eliminado. Los datos quedan archivados; no se borró nada.',
    },
  },
};
